// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:992px){.registration-header[data-v-c0e43a22]{position:absolute;left:0;right:0;z-index:100}}.registration-header__inner[data-v-c0e43a22]{display:flex;justify-content:space-between;align-items:flex-start;padding:0 32px}@media(max-width:991px){.registration-header__inner[data-v-c0e43a22]{justify-content:center}}@media(max-width:991px){.registration-header__login-button[data-v-c0e43a22]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
